<template>
    <div id="page" >
        <div class="container">
            <div  style="background-color: rgba(241, 241, 241, 1);padding:15px;font-size: 14px;">
                <template v-for="(item,index) in routerList">
                    <span  :key="index"> <router-link :to="{ path:item.path==''?'/':item.path}" >{{item.meta.title}} > </router-link></span>
                </template>
                <span>{{detail!=null?detail.title:null}}</span>
            </div>
            <div style="padding:10px;min-height: 600px;" v-if="detail!=null">
                <span v-html="detail.textDescribe"
                      style="color:#000000;font-size: 16px;"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {articleDetail} from "@/api/home"

    export default {
        name: "index",
        data() {
            return {
                detail:null,
                routerList:[]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route",this.$route)
            this.routerList = []
            for (let i=0;i<this.$route.matched.length-1;i++){
                this.routerList.push(this.$route.matched[i])
            }
            this.articleDetail(this.$route.query.id)
        },
        created() {

        },
        methods: {
            articleDetail(id){
                articleDetail({id:id}).then(res=>{
                    console.log(res)
                    this.detail = res.data
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .container{
        width: 1200px;
        min-width: 375px;
    }
</style>
